import { connect } from 'react-redux';

import {
  getIsAppBannerEnabled,
  getIsHomepage,
  getIsMobile,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import { BannerController } from './BannerController';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  isHomepage: getIsHomepage(state),
  isAppBannerEnabled: getIsAppBannerEnabled(state),
  isWhitelabel: getIsWhitelabel(state),
});

const connector = connect(mapStateToProps);

export default connector(BannerController);
